import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HostListener } from '@angular/core';
import { RoutingVariablesService } from 'src/app/shared/services/routing-variables.service'
import { AngularFirestore } from '@angular/fire/firestore';
import { MatDialog } from '@angular/material/dialog';
import { SignInComponent } from '../../autenticacion/sign-in/sign-in.component';
import { SignUpComponent } from '../../autenticacion/sign-up/sign-up.component';
import { AngularFireFunctions } from '@angular/fire/functions';
import VimeoPlayer from "@vimeo/player";
import { DomSanitizer } from '@angular/platform-browser';
import { SeoService } from 'src/app/services/seo.service';

export interface curso {
  adicionales: string[];
  cantArchivos: number;
  cantVentas: number;
  categoria: string;
  descripcion: string;
  dictaEmpresa: boolean;
  dirigidoA: string;
  duracion: number;
  empresaDescripcion: string;
  empresaFoto: string;
  empresaId: string;
  empresaNombre: string;
  empresaResumen: string;
  fechaCreacion: Date;
  foto: string;
  idioma: string;
  nivel: string,
  instructorDescripcion: string;
  instructorFoto: string;
  instructorId: string;
  instructorNombre: string;
  instructorResumen: string;
  porcentajeDescuento: number;
  precioFinal: number;
  precioOriginal: number;
  publicado: boolean;
  queAprenderas: string[];
  resumen: string;
  titulo: string;
}

export interface clase {
  numero: number;
  tipo: string;
  titulo: string;
  descripcion: string[];
  duracion: number;
  id: string;
}

export interface sesion {
  clases: clase[],
  duracion: number,
}

export interface valoracion {
  comentario: string,
  completado: boolean,
  conocimientos: number,
  global: number,
  instructor: number,
  material: number,
  plataforma: number,
  fecha: string,
}

export interface valoracionCompleta {
  cursoId: string,
  usuarioId: string,
  usuarioNombreCompleto: string,
  usuarioPhotoURL: string,
  valoracion: valoracion
}

@Component({
  selector: 'app-detalle-curso',
  templateUrl: './detalle-curso.component.html',
  styleUrls: ['./detalle-curso.component.css']
})
export class DetalleCursoComponent implements OnInit {

  // variables de valoracion
  valoraciones: valoracionCompleta[] = []
  valGlobal: number = 0;
  valInstructor: number = 0;
  valMaterial: number = 0;
  valConocimientos: number = 0;

  backColor = 'black';
  back1: string = "assets/images/background/back1.jpg";
  mostrarInfo: number;
  curso1: string = "assets/images/cursos/curso1.jpg";
  d: any;
  porcentaje: number = 22;
  loaded = 0;


  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private shared: RoutingVariablesService,
    private afs: AngularFirestore,
    public dialog: MatDialog,
    private functions: AngularFireFunctions,
    private sanitizer: DomSanitizer,
    private seo: SeoService,
  ) { }

  id = this.route.snapshot.paramMap.get('id');
  curso: curso;
  sesion: sesion;
  cursosRelacionados: any[] = [];
  inscrito = false
  fechaTope: any;
  
  logged = 0;
  usuario = JSON.parse(localStorage.getItem('user'));
  token = JSON.parse(localStorage.getItem('token'));

  // Video 
  private player;
  idVideo;
  safeUrl;
  mostrarVideo = false;

  // Ver mas
  cantClases = 10
  verMasFlag = false;
  botonVerMas = false;

  ngOnInit() {
    this.cargarVideoIntroduccion();
    if (this.usuario != null) {
      this.logged = 1;
      this.verificarInscripcion();
    } else {
      this.logged = 0;
      this.cargarCurso();
    }
  }

  async cargarCurso() {
    this.afs.collection('cursos').doc(this.id).ref.get().then((snap) => {
      const curso = snap.data();
      this.curso = {
        adicionales: curso['adicionales'],
        cantArchivos: curso['cantArchivos'],
        cantVentas: curso['cantVentas'],
        categoria: curso['categoria'],
        descripcion: curso['descripcion'],
        dictaEmpresa: curso['dictaEmpresa'],
        dirigidoA: curso['dirigidoA'],
        duracion: curso['duracion'],
        empresaDescripcion: curso['empresaDescripcion'],
        empresaFoto: curso['empresaFoto'],
        empresaId: curso['empresaId'],
        empresaNombre: curso['empresaNombre'],
        empresaResumen: curso['empresaResumen'],
        fechaCreacion: curso['fechaCreacion'],
        foto: curso['foto'],
        idioma: curso['idioma'],
        nivel: curso["nivel"],
        instructorDescripcion: curso['instructorDescripcion'],
        instructorFoto: curso['instructorFoto'],
        instructorId: curso['instructorId'],
        instructorNombre: curso['instructorNombre'],
        instructorResumen: curso['instructorResumen'],
        porcentajeDescuento: curso['porcentajeDescuento'],
        precioFinal: curso['precioFinal'],
        precioOriginal: curso['precioOriginal'],
        publicado: curso['publicado'],
        queAprenderas: curso['queAprenderas'],
        resumen: curso['resumen'],
        titulo: curso['titulo'],
      }
      this.seo.generateTags({
        title: this.curso.titulo,
        image: this.curso.foto,
        description: this.curso.descripcion,
      })
      // console.log(this.curso)
      this.cargarCursosRelacionados();
      this.cargarSesion();
    })
  }

  verificarInscripcion() {
    console.log(this.usuario.uid)
    console.log(this.token)
    this.afs.collection('usuariosProgresos').ref.where('usuarioId', '==', this.usuario.uid).where('cursoId', '==', this.id).get().then(response => {
      if (response.docs.length > 0) {
        // console.log('esta inscrito')
        this.inscrito = true
      } else {
        // console.log('no esta inscrito')
      }
      this.cargarCurso();
    }).catch(error => {
      console.log(error)
    })
  }

  async cargarCursosRelacionados() {
    this.afs.collection('cursos').ref.where('categoria', "==", this.curso.categoria).get().then(response => {
      let contador = 0
      response.docs.forEach(doc => {
        contador += 1;
        const curso = {
          id: doc.id,
          ...doc.data() as {}
        }
        if (doc.id != this.id) {
          if (curso["publicado"] == true) {
            this.cursosRelacionados = this.cursosRelacionados.concat(curso);
          }
        }
        if (contador == response.docs.length) {
          this.rellenarCursos();
        }
        console.log(this.cursosRelacionados)
      })
    })
  }

  rellenarCursos() {
    if (this.cursosRelacionados.length == 4) {
    } else {
      this.afs.collection("cursos").ref.limit(8).get().then(response => {
        let contador = this.cursosRelacionados.length;
        response.docs.forEach(doc => {
          const curso = {
            id: doc.id,
            ...doc.data() as {}
          }
          if (contador == 4) {
          } else {
            if (!this.cursosRelacionados.find(x=> x.id == curso.id)) {
              if (curso["publicado"] == true) {
                this.cursosRelacionados = this.cursosRelacionados.concat(curso);
              }
              contador += 1
            }
          }
        })
      })
    }
  }
  
  cargarSesion() {
    this.afs.collection('sesionesVisitante').doc(this.id).ref.get().then((snap)=>{
      const sesion = snap.data()
      this.sesion = sesion as sesion;
      if (this.sesion.clases.length > 10) {
        this.botonVerMas = true;
      }
      this.cargarFecha();

    }).catch(error => {
      console.log(error)
    })
  }

  buscarCategoria() {
    const categoria = this.curso.categoria;
    const obj = { categoria: categoria };
    this.shared.pushData(obj);
    this.router.navigate(['/buscar']);
  }

  regresarCursos() {
    const obj = { tipoBusqueda: "cursos"};
    this.shared.pushData(obj);
    this.router.navigate(['/buscar']);
  }

  cargarFecha() {
    this.afs.collection('global').doc('fechas').ref.get().then((snap) => {
      this.fechaTope = snap.data()['fechaDescuento'];
      this.loaded = 1;
      this.cargarValoraciones();
    }).catch(error => {
      console.log(error)
    })
  }

  cargarValoraciones() {
    this.afs.collection('cursosValoraciones').doc(this.id).ref.get().then((snap) => {
      if (snap.exists) {
        const valoraciones = snap.data();
        let arr = []
        Object.keys(valoraciones).map(function (key) {
          arr.push(valoraciones[key])
          return arr;
        });
        const length = arr.length
        let arreglo = []
        for (let index = 0; index < length; index++) {
          const valoracion: valoracion = arr[index]
          arreglo.push(valoracion)
        }
        this.valoraciones = arreglo;
        for (let i = 0; i < this.valoraciones.length; i++) {
          this.valGlobal += this.valoraciones[i].valoracion.global/this.valoraciones.length;
          this.valMaterial += this.valoraciones[i].valoracion.material/this.valoraciones.length; 
          this.valInstructor += this.valoraciones[i].valoracion.instructor/this.valoraciones.length;
          this.valConocimientos += this.valoraciones[i].valoracion.conocimientos/this.valoraciones.length;
        }
        this.valoraciones.sort((a,b) => a.valoracion.global - b.valoracion.global);
      }      
    })
  }

  cargarVideoIntroduccion() {
    console.log(this.id)
    this.functions.httpsCallable("cargarVideoIntroduccion")({
      cursoId: this.id,
    }).toPromise().then((idVideo) => {
      this.idVideo = +idVideo
      if (typeof this.idVideo == 'number' && this.idVideo > 0) {
        this.mostrarVideo = true
      }
      console.log(this.mostrarVideo)
      console.log(this.idVideo);
      const videoUrl = "https://player.vimeo.com/video/" + this.idVideo + "?title=0&amp;byline=0&amp;portrait=0&amp;speed=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479";
      this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(videoUrl);
    }).catch((error) => {
      this.mostrarVideo = false;
      console.log(error);
    })
  }

  initPlayer() {
    var iframe = document.querySelector('iframe');
    this.player = new VimeoPlayer(iframe, {});
  }

  openLogIn() {
    const dialogRef = this.dialog.open(SignInComponent);
    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

  openSignUp() {
    const dialogRef = this.dialog.open(SignUpComponent);
    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

  verMas() {
    this.cantClases = this.sesion.clases.length;
    this.verMasFlag = true;
  }

  verMenos() {
    this.cantClases = 10;
    this.verMasFlag = false;
  }

  @HostListener('window:scroll', [])
  onWindowScrollDown() {
    let d = document.getElementById("infoGeneralCurso").offsetTop;
    if (window.pageYOffset > d - 90) {
      this.backColor = 'white';

    } else if (window.pageYOffset < d - 30) {
      this.backColor = 'black';
    }
  }

  reload() {
    location.reload();
  }


}

